import * as actionTypes from "./constants";

const initialState = {
  processing: false,
  error: false,
  fetchdriverList: [],
};

export default function MyDriverReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_DRIVERPROF_SUCCESS_ACTION:
      return {
        ...state,
        processing: false,
        driverList: action.payload.rows,
        driverCount: action.payload.count,
      };
    case actionTypes.FETCH_DRIVERPROF_ACTION:
      return {
        ...state,
        processing: true,
      };
    case actionTypes.FETCH_DRIVERBYID_SUCCESS_ACTION:
      return {
        ...state,
        fetchdriverList: action.payload,
      };

    case actionTypes.FETCH_PROFCOUNTRY_SUCCESS_ACTION:
      return {
        ...state,
        countrydetailList: action.payload.rows,
      };
    case actionTypes.FETCH_REGION_SUCCESS_ACTION:
      return {
        ...state,
        regionList: action.payload.rows,
      };
    case actionTypes.FETCH_LOCATION_SUCCESS_ACTION:
      return {
        ...state,
        locationList: action.payload.rows,
      };
    case actionTypes.FETCH_OPEQUIPMENT_SUCCESS_ACTION:
      return {
        ...state,
        equipmentList: action.payload.rows,
      };
    case actionTypes.FETCH_CARGOTYPE_SUCCESS_ACTION:
      return {
        ...state,
        cargotypeList: action.payload.rows,
      };
    case actionTypes.FETCH_OPENDRIVER_SUCCESS_ACTION:
      return {
        ...state,
        processing: false,
        opendriverList: action.payload.rows,
        opendriverCount: action.payload.count,
      };
      case actionTypes.FETCH_OPENDRIVER_ACTION:
        return {
          ...state,
          processing: true,
        };

    case actionTypes.FETCH_DRIVERTRIP_SUCCESS_ACTION:
      return {
        ...state,
        tripdriverList: action.payload.rows,
        tripdriverCount: action.payload.count,
      };

    default:
      return {
        ...state,
      };
  }
}
